export default "__VITE_ASSET__c6f1d87c__"